import { render, staticRenderFns } from "./BrdeLabsAwardSection.vue?vue&type=template&id=79768539&scoped=true"
import script from "./BrdeLabsAwardSection.vue?vue&type=script&lang=js"
export * from "./BrdeLabsAwardSection.vue?vue&type=script&lang=js"
import style0 from "./BrdeLabsAwardSection.vue?vue&type=style&index=0&id=79768539&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79768539",
  null
  
)

export default component.exports